/* exported hashHelper */

/**
* @author Firefall
* @version 0.0.1
*/

var hashHelper = {
  // Separator to use to separate hash values, defaults to '/'
  seperator: '/',
  /**
  * @name deeplinkHelper.get
  * @description Gets the current hash values after stilling away the leading # and separator
  * @returns {Array} An array of hash values
  */
  get: function() {
    var hashRaw = window.location.hash.trim().replace(new RegExp('^#+' + (this.seperator.length !== 0 ? this.seperator + '*' : this.seperator)), '');
    var hashData;

    if (hashRaw.length === 0) {
      return [];
    }

    hashData = hashRaw.split(this.seperator);

    return hashData;
  },
  /**
  * @name deeplinkHelper.set
  * @description Sets hash values, this also clears previous hash values.
  * @param {string|number|Array} value A string, number, or Array of values to add to the hash
  * @returns {undefined} Nothing
  */
  set: function(value) {
    var hashString = '';

    if (typeof value === 'string' || typeof value === 'number') {
      window.location.replace('#' + this.seperator + value);
    } else if (typeof value === 'object' && value instanceof Array) {
      // Iterate over array
      value.forEach(function(hashValue) {
        if (typeof hashValue === 'string' || typeof hashValue === 'number') {
          hashString += (hashString.length === 0 ? '' : this.seperator) + hashValue;
        }
      });

      window.location.replace('#' + this.seperator + hashString);
    }
  }
};
